/* v05_a24-dawn-refactor/assets/a24-product-page.js */
/* Product page: variants, price state, enquiry guard, gallery, lightbox and product tabs. */
(function () {
  'use strict';

  var productData = {};
  var CONTACT_PRICE_THRESHOLD_AMOUNT = 0;
  var FORCE_PRICE_ON_REQUEST = false;
  var lightboxImages = [];
  var lightboxIdx = 0;
  var initialized = false;

  function readConfig() {
    // Liquid stellt nur JSON bereit; die Produktlogik parst diese Daten zentral hier.
    var config = window.A24ProductPageConfig || {};
    var configNode = document.querySelector('[data-a24-product-page-config]');
    var rawConfigText = '';

    if (configNode) {
      if (String(configNode.tagName || '').toUpperCase() === 'TEMPLATE' && configNode.content) {
        rawConfigText = String(configNode.content.textContent || '').trim();
      } else {
        rawConfigText = String(configNode.textContent || '').trim();
      }
    }

    if (rawConfigText) {
      try {
        config = JSON.parse(rawConfigText);
      } catch (error) {
        console.warn('A24 product config konnte nicht gelesen werden.', error);
      }
    }

    productData = config.product || {};
    var thresholdEnabled = config.contactPriceThresholdEnabled !== false;
    var thresholdEur = Number(config.contactPriceThresholdEur || 0);
    var factorValue = Number(config.contactPriceThresholdFactor || 0);
    var factorBase = Number(config.contactPriceThresholdFactorBase || 0);
    var factorThresholdAmount = 0;
    var euroThresholdAmount = 0;
    if (thresholdEnabled && thresholdEur > 0) {
      euroThresholdAmount = thresholdEur * 100;
    }
    if (thresholdEnabled && factorValue > 0) {
      factorValue = Math.min(200, Math.max(1, factorValue));
    }
    if (thresholdEnabled && factorValue > 0 && factorBase > 0) {
      factorThresholdAmount = factorValue * factorBase * 100;
    }

    CONTACT_PRICE_THRESHOLD_AMOUNT = factorThresholdAmount || euroThresholdAmount;
    FORCE_PRICE_ON_REQUEST = Boolean(config.forcePriceOnRequest);
    lightboxImages = Array.isArray(config.lightboxImages) ? config.lightboxImages : [];
    lightboxIdx = Number(config.lightboxIndex || 0);
  }

  function applyProductInlineSpacing() {
    // Ersetzt fruehere Liquid-Inline-Styles für das optionale Titel-Logo.
    document.querySelectorAll('[data-a24-inline-start], [data-a24-inline-end]').forEach(function (node) {
      var start = parseInt(node.getAttribute('data-a24-inline-start') || '0', 10);
      var end = parseInt(node.getAttribute('data-a24-inline-end') || '0', 10);

      if (!Number.isNaN(start)) {
        node.style.paddingInlineStart = Math.max(0, start) + 'px';
      }

      if (!Number.isNaN(end)) {
        node.style.paddingInlineEnd = Math.max(0, end) + 'px';
      }
    });
  }

function formatMoneyEur(amount) {
  var n = Number(amount || 0) / 100;
  var fixed = n.toFixed(2);
  var parts = fixed.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return parts[0] + ',' + parts[1] + ' \u20ac';
}

function initHighPriceContactGuard() {
  var form = document.getElementById('ProductForm');
  if (!form || !productData || !Array.isArray(productData.variants)) return;

  var addBtn = form.querySelector('button[name="add"]');
  var noteEl = document.getElementById('productContactNote');
  var modal = document.getElementById('highPriceContactModal');
  var closeEls = modal ? modal.querySelectorAll('[data-modal-close]') : [];
  var variantIdInput = form.querySelector('input[name="id"]');
  var motorProductEl = document.getElementById('motorContactProduct');
  var motorVariantEl = document.getElementById('motorContactVariant');
  var motorPriceEl = document.getElementById('motorContactPrice');
  var motorProductInput = document.getElementById('motorContactProductInput');
  var motorVariantInput = document.getElementById('motorContactVariantInput');
  var motorPriceInput = document.getElementById('motorContactPriceInput');
  var motorBodyField = document.getElementById('motorContactBody');
  var postedFlag = document.getElementById('highPriceContactPostedFlag');
  var toast = document.getElementById('highPriceContactToast');

  function getVariantById() {
    if (!variantIdInput) return null;
    var currentId = Number(variantIdInput.value || 0);
    if (!currentId) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (Number(productData.variants[i].id) === currentId) return productData.variants[i];
    }
    return null;
  }

  function isAboveThreshold(variant) {
    if (!variant) return false;
    if (typeof FORCE_PRICE_ON_REQUEST !== 'undefined' && FORCE_PRICE_ON_REQUEST) return true;
    var price = Number(variant.price || 0);
    if (price === 0) return true;
    return price >= CONTACT_PRICE_THRESHOLD_AMOUNT;
  }

  function buildVariantLabel(variant) {
    if (!variant) return 'Standard';
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    if (Array.isArray(variant.options)) {
      var visibleOptions = variant.options.filter(function (value) {
        return !!String(value || '').trim();
      });
      if (visibleOptions.length) return visibleOptions.join(' / ');
    }
    return 'Standard';
  }

  function buildBodyTemplate(productTitle, variantLabel, priceLabel) {
    return [
      'Hallo,',
      '',
      'ich interessiere mich für folgenden Motor und bitte um Beratung:',
      '- Produkt: ' + productTitle,
      '- Variante: ' + variantLabel,
      '- Preis: ' + priceLabel,
      '',
      'Bitte kontaktieren Sie mich mit Verfügbarkeit und Angebot.',
      ''
    ].join('\n');
  }

  function updateMotorContactInfo(variant) {
    if (!variant) return;

    var productTitle = String(productData.title || 'Motor');
    var variantLabel = buildVariantLabel(variant);
    var forced = (typeof FORCE_PRICE_ON_REQUEST !== 'undefined' && FORCE_PRICE_ON_REQUEST);
    var priceLabel = (forced || Number(variant.price || 0) === 0) ? 'Preis auf Anfrage' : formatMoneyEur(variant.price);

    if (motorProductEl) motorProductEl.textContent = productTitle;
    if (motorVariantEl) motorVariantEl.textContent = variantLabel;
    if (motorPriceEl) motorPriceEl.textContent = priceLabel;

    if (motorProductInput) motorProductInput.value = productTitle;
    if (motorVariantInput) motorVariantInput.value = variantLabel;
    if (motorPriceInput) motorPriceInput.value = priceLabel;

    if (motorBodyField && motorBodyField.dataset.userEdited !== 'true') {
      motorBodyField.value = buildBodyTemplate(productTitle, variantLabel, priceLabel);
    }
  }

  function showSuccessToast() {
    if (!toast) return;
    toast.hidden = false;
    window.setTimeout(function () {
      toast.hidden = true;
    }, 4200);
  }

  function openModal() {
    if (!modal) return;
    updateMotorContactInfo(getVariantById());
    modal.hidden = false;
    document.body.classList.add('modal-open');
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('modal-open');
  }

  function updateButtonState(variant) {
    if (!addBtn || !variant) return;

    var available = !!variant.available;
    var blockedByPrice = available && isAboveThreshold(variant);

    addBtn.dataset.highPriceBlocked = blockedByPrice ? 'true' : 'false';
    addBtn.disabled = !available;

    if (!available) {
      addBtn.textContent = 'Ausverkauft';
    } else if (blockedByPrice) {
      addBtn.textContent = 'Beratung anfragen';
    } else {
      addBtn.textContent = 'In den Warenkorb';
    }

    if (noteEl) {
      noteEl.hidden = !blockedByPrice;
    }

    updateMotorContactInfo(variant);
  }

  if (modal) {
    closeEls.forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });
  }

  if (motorBodyField) {
    motorBodyField.addEventListener('input', function () {
      motorBodyField.dataset.userEdited = 'true';
    });
  }

  if (addBtn) {
    addBtn.addEventListener('click', function (event) {
      if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
      if (addBtn.dataset.highPriceBlocked === 'true') {
        event.preventDefault();
        openModal();
      }
    });
  }

  form.addEventListener('submit', function (event) {
    if (window.A24Theme?.shouldProtectEditorClicks?.()) return;
    var variant = getVariantById();
    if (variant && variant.available && isAboveThreshold(variant)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openModal();
    }
  }, true);

  if (postedFlag) {
    showSuccessToast();
  }

  window.updateHighPriceContactState = updateButtonState;
  updateButtonState(getVariantById());
}

function syncProductVariantState() {
  var form = document.getElementById('ProductForm');
  if (!form || !productData || !Array.isArray(productData.variants)) return;

  var optionSelects = Array.prototype.slice.call(form.querySelectorAll('select[name^="options["]'));
  if (!optionSelects.length) return;

  var variantIdInput = form.querySelector('input[name="id"]');
  var priceWrap = document.getElementById('productPrice');
  var skuEl = document.querySelector('.product-info__sku');
  var addBtn = form.querySelector('button[name="add"]');

  function normalizeOptionValue(v) {
    return String(v == null ? '' : v).trim();
  }

  function findVariantByOptions() {
    var selectedValues = optionSelects.map(function (s) { return normalizeOptionValue(s.value); });
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var matches = true;
      for (var j = 0; j < selectedValues.length; j++) {
        if (normalizeOptionValue(v.options[j]) !== selectedValues[j]) {
          matches = false;
          break;
        }
      }
      if (matches) return v;
    }
    return null;
  }

  function renderVariantPrice(variant) {
    if (!priceWrap || !variant) return;
    if ((typeof FORCE_PRICE_ON_REQUEST !== 'undefined' && FORCE_PRICE_ON_REQUEST) || Number(variant.price || 0) === 0) {
      priceWrap.innerHTML = '<span class="product-info__price-current">Preis auf Anfrage</span>';
      return;
    }
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var savedAmount = Number(variant.compare_at_price || 0) - Number(variant.price || 0);
      priceWrap.innerHTML =
        '<span class="product-info__price-old">' + formatMoneyEur(variant.compare_at_price) + '</span>' +
        '<span class="product-info__price-current">' + formatMoneyEur(variant.price) + '</span>' +
        '<span class="product-info__price-save">Du sparst: <strong>' + formatMoneyEur(savedAmount) + '</strong></span>';
      return;
    }
    priceWrap.textContent = formatMoneyEur(variant.price);
  }

  function formatSignedMoney(amountDelta) {
    var sign = amountDelta > 0 ? '+' : '-';
    return sign + formatMoneyEur(Math.abs(amountDelta));
  }

  function updateSelectOptionLabelsWithStandardDelta(activeVariant) {
    if (!optionSelects.length || !productData || !Array.isArray(productData.variants)) return;
    if (!activeVariant) return;

    var selectedValues = optionSelects.map(function (s) { return normalizeOptionValue(s.value); });

    optionSelects.forEach(function (selectEl, selectIdx) {
      var optionPos = selectIdx;

      Array.prototype.slice.call(selectEl.options).forEach(function (opt) {
        var baseLabel = opt.getAttribute('data-base-label') || opt.textContent;
        if (!opt.getAttribute('data-base-label')) {
          opt.setAttribute('data-base-label', baseLabel);
        }

        var targetVariant = null;
        var targetVariantFallback = null;
        for (var i = 0; i < productData.variants.length; i++) {
          var v = productData.variants[i];
          if (normalizeOptionValue(v.options[optionPos]) !== normalizeOptionValue(opt.value)) continue;

          var sameOtherOptions = true;
          for (var j = 0; j < selectedValues.length; j++) {
            if (j === optionPos) continue;
            if (normalizeOptionValue(v.options[j]) !== selectedValues[j]) {
              sameOtherOptions = false;
              break;
            }
          }
          if (sameOtherOptions) {
            if (v.available && !targetVariant) {
              targetVariant = v;
              break;
            }
            if (!targetVariantFallback) {
              targetVariantFallback = v;
            }
          }
        }

        if (!targetVariant) {
          targetVariant = targetVariantFallback;
        }

        if (!targetVariant) {
          for (var k = 0; k < productData.variants.length; k++) {
            var fallbackVariant = productData.variants[k];
            if (normalizeOptionValue(fallbackVariant.options[optionPos]) === normalizeOptionValue(opt.value)) {
              targetVariant = fallbackVariant;
              break;
            }
          }
        }

        if (!targetVariant) {
          opt.textContent = baseLabel;
          return;
        }

        var delta = Number(targetVariant.price) - Number(activeVariant.price || 0);
        opt.textContent = baseLabel + ' (' + formatSignedMoney(delta) + ')';
      });
    });
  }

  function applyVariantFromUrlParam() {
    if (!window.URLSearchParams) return;
    var params = new URLSearchParams(window.location.search);
    var variantParam = Number(params.get('variant') || 0);
    if (!variantParam) return;

    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      if (Number(v.id) !== variantParam) continue;
      optionSelects.forEach(function (selectEl, idx) {
        var nextVal = normalizeOptionValue(v.options[idx]);
        if (!nextVal) return;
        selectEl.value = nextVal;
      });
      break;
    }
  }

  function applyVariantState() {
    var variant = findVariantByOptions();

    if (!variant) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Nicht verf\u00fcgbar';
      }
      if (typeof window.updateHighPriceContactState === 'function') {
        window.updateHighPriceContactState(null);
      }
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    renderVariantPrice(variant);
    updateSelectOptionLabelsWithStandardDelta(variant);

    if (skuEl) {
      if (variant.sku) {
        skuEl.textContent = 'SKU: ' + variant.sku;
        skuEl.style.display = '';
      } else {
        skuEl.style.display = 'none';
      }
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
    }

    if (typeof window.updateHighPriceContactState === 'function') {
      window.updateHighPriceContactState(variant);
    }

    if (window.history && window.history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', u.toString());
    }
  }

  optionSelects.forEach(function (selectEl) {
    selectEl.addEventListener('change', applyVariantState);
    selectEl.addEventListener('input', applyVariantState);
  });

  applyVariantFromUrlParam();
  applyVariantState();
}

function initProductMediaCarousel() {
  var carousel = document.querySelector('[data-product-carousel]');
  if (!carousel) return;

  var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-product-slide]'));
  if (!slides.length) return;

  var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-product-dot]'));
  var thumbs = Array.prototype.slice.call(carousel.querySelectorAll('[data-product-thumb]'));
  var thumbsTrack = carousel.querySelector('[data-product-thumbs-track]');
  var thumbsPrevBtn = carousel.querySelector('[data-product-thumbs-prev]');
  var thumbsNextBtn = carousel.querySelector('[data-product-thumbs-next]');
  var prevBtn = carousel.querySelector('[data-product-prev]');
  var nextBtn = carousel.querySelector('[data-product-next]');
  var counter = carousel.querySelector('[data-product-counter]');
  var thumbScrollTicking = false;
  var activeIndex = slides.findIndex(function (slide) {
    return slide.classList.contains('is-active');
  });

  if (activeIndex < 0) activeIndex = 0;

  function getThumbScrollStep() {
    if (!thumbsTrack) return 0;
    var firstThumb = thumbs[0];
    if (!firstThumb) return Math.max(120, thumbsTrack.clientWidth * 0.75);

    var thumbRect = firstThumb.getBoundingClientRect();
    var trackStyles = window.getComputedStyle(thumbsTrack);
    var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    var base = thumbRect.width + gap;
    return Math.max(120, base * 4);
  }

  function updateThumbNavState() {
    if (!thumbsTrack || !thumbsPrevBtn || !thumbsNextBtn) return;

    var maxScroll = Math.max(0, thumbsTrack.scrollWidth - thumbsTrack.clientWidth);
    var hasOverflow = maxScroll > 1;

    if (!hasOverflow) {
      thumbsPrevBtn.disabled = true;
      thumbsNextBtn.disabled = true;
      return;
    }

    thumbsPrevBtn.disabled = thumbsTrack.scrollLeft <= 1;
    thumbsNextBtn.disabled = thumbsTrack.scrollLeft >= (maxScroll - 1);
  }

  function scrollThumbs(direction) {
    if (!thumbsTrack) return;
    thumbsTrack.scrollBy({
      left: getThumbScrollStep() * direction,
      behavior: 'smooth'
    });
  }

  function render(index) {
    activeIndex = (index + slides.length) % slides.length;

    slides.forEach(function (slide, i) {
      var isActive = i === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    dots.forEach(function (dot, i) {
      var isActive = i === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    thumbs.forEach(function (thumb, i) {
      var isActive = i === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var activeThumb = thumbs[activeIndex];
    if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
      activeThumb.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    updateThumbNavState();

    if (counter) {
      counter.textContent = (activeIndex + 1) + ' / ' + slides.length;
    }

    lightboxIdx = activeIndex;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () { render(activeIndex - 1); });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () { render(activeIndex + 1); });
  }

  if (thumbsPrevBtn) {
    thumbsPrevBtn.addEventListener('click', function () {
      scrollThumbs(-1);
    });
  }

  if (thumbsNextBtn) {
    thumbsNextBtn.addEventListener('click', function () {
      scrollThumbs(1);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      render(parseInt(dot.getAttribute('data-slide-index') || '0', 10));
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      render(parseInt(thumb.getAttribute('data-slide-index') || '0', 10));
    });
  });

  slides.forEach(function (slide) {
    slide.addEventListener('click', function () {
      openLightbox(parseInt(slide.getAttribute('data-slide-index') || '0', 10));
    });
  });

  if (thumbsTrack) {
    thumbsTrack.addEventListener('scroll', function () {
      if (thumbScrollTicking) return;
      thumbScrollTicking = true;
      window.requestAnimationFrame(function () {
        updateThumbNavState();
        thumbScrollTicking = false;
      });
    });
  }

  window.addEventListener('resize', updateThumbNavState);

  render(activeIndex);
}

function initProductTabs() {
  function refreshJudgeMeWidgets(scope) {
    if (!scope || !scope.querySelector('.jdgm-widget')) return;

    window.setTimeout(function () {
      if (window.jdgm && typeof window.jdgm.reloadWidgets === 'function') {
        window.jdgm.reloadWidgets();
        return;
      }

      if (window.jdgm && typeof window.jdgm.refreshWidgets === 'function') {
        window.jdgm.refreshWidgets();
        return;
      }

      if (typeof window.jdgmShopifyInitWidgets === 'function') {
        window.jdgmShopifyInitWidgets();
      }
    }, 0);
  }

  document.querySelectorAll('.product-tabs').forEach(function (tabs) {
    var buttons = tabs.querySelectorAll('.product-tabs__btn');
    var panels = tabs.querySelectorAll('.product-tabs__panel');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = this.dataset.tab;

        buttons.forEach(function (button) {
          button.classList.remove('is-active');
          button.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
          panel.hidden = true;
        });

        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        var panel = tabs.querySelector('#tab-' + CSS.escape(tab));
        if (panel) {
          panel.classList.add('is-active');
          panel.hidden = false;
          refreshJudgeMeWidgets(panel);
        }
      });
    });
  });

  document.querySelectorAll('.product-mobile-accordion__item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      refreshJudgeMeWidgets(item);
    });
  });
}

function removeBoilerplateDescriptionParagraphs() {
  var descriptionRoots = document.querySelectorAll('.prose--product');
  if (!descriptionRoots.length) return;

  descriptionRoots.forEach(function (descriptionRoot) {
    descriptionRoot.querySelectorAll('p').forEach(function (paragraph) {
      var text = String(paragraph.textContent || '')
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/ß/g, 'ss');

      if (!text) return;

      var isSuzukiBoilerplate = text.indexOf('original suzuki teile und passende komponenten') !== -1
        && text.indexOf('preis- und bildmaterial wird fortlaufend') !== -1;

      if (isSuzukiBoilerplate) {
        paragraph.remove();
      }
    });
  });
}

function prepareProductTables() {
  var tables = document.querySelectorAll('.product-tabs__panel .rte table, .product-mobile-accordion__content.rte table');
  if (!tables.length) return;

  var SPEC_ICON_MAP = {
    'eingangsleistung': 'icon-spec-input-power.svg',
    'eingangsleistung w': 'icon-spec-input-power.svg',
    'nennspannung': 'icon-spec-input-power.svg',
    'spannung': 'icon-spec-input-power.svg',
    'voltage input': 'icon-spec-input-power.svg',
    'input power': 'icon-spec-input-power.svg',
    'endladespannung': 'icon-spec-input-power.svg',
    'dauerleistung': 'icon-spec-continuous-power.svg',
    'dauerleistung w': 'icon-spec-continuous-power.svg',
    'continuous power': 'icon-spec-continuous-power.svg',
    'vergl verbrenner antriebsleistung ps': 'icon-spec-combustion-equivalent.svg',
    'vergleich verbrenner antriebsleistung ps': 'icon-spec-combustion-equivalent.svg',
    'vergleichbare verbrenner antriebsleistung': 'icon-spec-combustion-equivalent.svg',
    'verbrenner antriebsleistung': 'icon-spec-combustion-equivalent.svg',
    'combustion equivalent': 'icon-spec-combustion-equivalent.svg',
    'integrierter li ion akku wh': 'icon-spec-battery-capacity.svg',
    'integrierter li ion akku': 'icon-spec-battery-capacity.svg',
    'li ion akku': 'icon-spec-battery-capacity.svg',
    'akku wh': 'icon-spec-battery-capacity.svg',
    'akkukapazitaet': 'icon-spec-battery-capacity.svg',
    'akku kapazitaet': 'icon-spec-battery-capacity.svg',
    'batteriekapazitaet': 'icon-spec-battery-capacity.svg',
    'battery capacity': 'icon-spec-battery-capacity.svg',
    'gesamtgewicht kg': 'icon-spec-total-weight.svg',
    'gesamtgewicht': 'icon-spec-total-weight.svg',
    'total weight': 'icon-spec-total-weight.svg',
    'gewicht': 'icon-spec-total-weight.svg',
    'motorgewicht ohne akku kg': 'icon-spec-motor-weight.svg',
    'motorgewicht ohne akku': 'icon-spec-motor-weight.svg',
    'motor gewicht ohne akku': 'icon-spec-motor-weight.svg',
    'motorgewicht': 'icon-spec-motor-weight.svg',
    'motor weight': 'icon-spec-motor-weight.svg',
    'akkugewicht kg': 'icon-spec-battery-weight.svg',
    'akkugewicht': 'icon-spec-battery-weight.svg',
    'battery weight': 'icon-spec-battery-weight.svg',
    'schaftlaenge': 'icon-spec-shaft-length.svg',
    'schaftlaengen': 'icon-spec-shaft-length.svg',
    'shaft length': 'icon-spec-shaft-length.svg',
    'max propellerdrehzahl u min': 'icon-spec-propeller-rpm.svg',
    'max propellerdrehzahl': 'icon-spec-propeller-rpm.svg',
    'propellerdrehzahl': 'icon-spec-propeller-rpm.svg',
    'propeller rpm': 'icon-spec-propeller-rpm.svg',
    'steuerung': 'icon-spec-control.svg',
    'control': 'icon-spec-control.svg',
    'torqlink': 'icon-spec-torqlink.svg',
    'lenkung': 'icon-spec-steering.svg',
    'steering': 'icon-spec-steering.svg',
    'kippvorrichtung': 'icon-spec-tilt.svg',
    'tilt': 'icon-spec-tilt.svg',
    'trimmvorrichtung': 'icon-spec-trim.svg',
    'trim': 'icon-spec-trim.svg',
    'stufenloser vorwaerts rueckwaertsantrieb': 'icon-spec-variable-forward-reverse.svg',
    'vorwaerts rueckwaertsantrieb': 'icon-spec-variable-forward-reverse.svg',
    'variable forward reverse': 'icon-spec-variable-forward-reverse.svg',
    'leistung kw ps': 'icon-spec-power-kw-ps.svg',
    'leistungsstufe': 'icon-spec-power-kw-ps.svg',
    'power rating': 'icon-spec-power-kw-ps.svg',
    'leistung': 'icon-spec-power-kw-ps.svg',
    'hubraum': 'icon-spec-displacement.svg',
    'displacement': 'icon-spec-displacement.svg',
    'bohrung hub': 'icon-spec-bore-stroke.svg',
    'bohrung x hub': 'icon-spec-bore-stroke.svg',
    'bore stroke': 'icon-spec-bore-stroke.svg',
    'schaltung': 'icon-spec-gear-shift.svg',
    'gear shift': 'icon-spec-gear-shift.svg',
    'trimm und tilteinstellungen': 'icon-spec-trim-tilt-settings.svg',
    'trimm und tilt einstellungen': 'icon-spec-trim-tilt-settings.svg',
    'trimm und titeleinstellungen': 'icon-spec-trim-tilt-settings.svg',
    'trim tilt settings': 'icon-spec-trim-tilt-settings.svg',
    'trim und tilt': 'icon-spec-trim-tilt-settings.svg',
    'wechselstromgenerator': 'icon-spec-alternator.svg',
    'alternator': 'icon-spec-alternator.svg',
    'generator': 'icon-spec-alternator.svg',
    'getriebeuntersetzung': 'icon-spec-gear-ratio.svg',
    'gear ratio': 'icon-spec-gear-ratio.svg',
    'empf drehzahlbereich min': 'icon-spec-recommended-rpm-range.svg',
    'empfohlener drehzahlbereich': 'icon-spec-recommended-rpm-range.svg',
    'recommended rpm range': 'icon-spec-recommended-rpm-range.svg',
    'drehzahlbereich': 'icon-spec-recommended-rpm-range.svg',
    'anzahl der zylinder': 'icon-spec-cylinder-count.svg',
    'zylinderanzahl': 'icon-spec-cylinder-count.svg',
    'zylinder': 'icon-spec-cylinder-count.svg',
    'cylinder count': 'icon-spec-cylinder-count.svg',
    'einspritzsystem': 'icon-spec-fuel-injection.svg',
    'einspritzung': 'icon-spec-fuel-injection.svg',
    'direkteinspritzung': 'icon-spec-fuel-injection.svg',
    'common rail': 'icon-spec-fuel-injection.svg',
    'injection system': 'icon-spec-fuel-injection.svg',
    'fuel injection': 'icon-spec-fuel-injection.svg',
    'startsystem': 'icon-spec-start-system.svg',
    'elektrostart': 'icon-spec-start-system.svg',
    'start system': 'icon-spec-start-system.svg',
    'oelfuellmenge l': 'icon-spec-oil-capacity.svg',
    'oelfuellmenge': 'icon-spec-oil-capacity.svg',
    'oel fuellmenge': 'icon-spec-oil-capacity.svg',
    'oil capacity': 'icon-spec-oil-capacity.svg',
    'kuehlsystem': 'icon-spec-cooling-system.svg',
    'kuehlung': 'icon-spec-cooling-system.svg',
    'cooling system': 'icon-spec-cooling-system.svg',
    'zuendsystem': 'icon-spec-ignition-system.svg',
    'zundsystem': 'icon-spec-ignition-system.svg',
    'ignition system': 'icon-spec-ignition-system.svg',
    'kraftstofftankinhalt': 'icon-spec-fuel-tank-capacity.svg',
    'kraftstofftank': 'icon-spec-fuel-tank-capacity.svg',
    'tankinhalt': 'icon-spec-fuel-tank-capacity.svg',
    'fuel tank capacity': 'icon-spec-fuel-tank-capacity.svg',
    'eigenschaft': 'icon-spec-property.svg',
    'property': 'icon-spec-property.svg',
    'aufladung': 'icon-aspiration.svg',
    'ansaugung': 'icon-aspiration.svg',
    'aspiration': 'icon-aspiration.svg',
    'nenndrehzahl': 'icon-rated-speed.svg',
    'drehzahl': 'icon-rated-speed.svg',
    'rated speed': 'icon-rated-speed.svg',
    'speed': 'icon-rated-speed.svg',
    'engine rating': 'icon-engine-rating.svg',
    'rating': 'icon-engine-rating.svg',
    'emissionskurve': 'icon-emissions-curve.svg',
    'emissions curve': 'icon-emissions-curve.svg',
    'emissionskonformitaet': 'icon-emission-compliance.svg',
    'emissionskonformitat': 'icon-emission-compliance.svg',
    'emission compliance': 'icon-emission-compliance.svg',
    'emission': 'icon-emission-compliance.svg',
    'abmessungen': 'icon-dimensions.svg',
    'masse': 'icon-dimensions.svg',
    'maße': 'icon-dimensions.svg',
    'dimensions': 'icon-dimensions.svg',
    'kraftstoffart': 'icon-fuel-type.svg',
    'kraftstoff': 'icon-fuel-type.svg',
    'fuel type': 'icon-fuel-type.svg',
    'hersteller': 'icon-brand.svg',
    'manufacturer': 'icon-brand.svg',
    'brand': 'icon-brand.svg',
    'modellfamilie': 'icon-model.svg',
    'model family': 'icon-model.svg',
    'model': 'icon-model.svg',
    'variante': 'icon-variant.svg',
    'variant': 'icon-variant.svg',
    'anwendung': 'icon-boat-application.svg',
    'boat application': 'icon-boat-application.svg',
    'application': 'icon-boat-application.svg',
    'antriebssystem': 'icon-drive-system.svg',
    'drive system': 'icon-drive-system.svg',
    'elektrische leistung kwe': 'icon-electric-power.svg',
    'elektrische leistung': 'icon-electric-power.svg',
    'electric output kwe': 'icon-electric-power.svg',
    'electric power': 'icon-electric-power.svg',
    'kwe': 'icon-electric-power.svg',
    'mechanische leistung kwm': 'icon-mechanical-power.svg',
    'mechanische leistung': 'icon-mechanical-power.svg',
    'antriebsleistung w': 'icon-mechanical-power.svg',
    'mechanical output kwm': 'icon-mechanical-power.svg',
    'mechanical power': 'icon-mechanical-power.svg',
    'kwm': 'icon-mechanical-power.svg',
    'rated power': 'icon-rated-power.svg',
    'motorbauart': 'icon-engine.svg',
    'engine type': 'icon-engine.svg',
    'engine': 'icon-engine.svg',
    'motor': 'icon-engine.svg',
    'ausstattung': 'icon-equipment.svg',
    'equipment': 'icon-equipment.svg',
    'auspuff': 'icon-exhaust.svg',
    'exhaust': 'icon-exhaust.svg',
    'propelleroptionen': 'icon-propeller.svg',
    'propellersteigung': 'icon-propeller.svg',
    'propeller': 'icon-propeller.svg',
    'verdichtung': 'icon-compression-ratio.svg',
    'compression ratio': 'icon-compression-ratio.svg',
    'drehmoment': 'icon-torque.svg',
    'torque': 'icon-torque.svg',
    'verbrennungsverfahren': 'icon-combustion-process.svg',
    'combustion process': 'icon-combustion-process.svg',
    'elektrisches system': 'icon-electrical-system.svg',
    'electrical system': 'icon-electrical-system.svg',
    'einbauwinkel': 'icon-installation-angle.svg',
    'einbaulage': 'icon-installation-angle.svg',
    'installation angle': 'icon-installation-angle.svg',
    'kuehlwasser einlass': 'icon-cooling-water-inlet.svg',
    'cooling water inlet': 'icon-cooling-water-inlet.svg',
    'kraftstoff einlass': 'icon-fuel-inlet.svg',
    'diesel einlass': 'icon-fuel-inlet.svg',
    'fuel inlet': 'icon-fuel-inlet.svg',
    'kraftstoff ruecklauf': 'icon-fuel-return.svg',
    'diesel ruecklauf': 'icon-fuel-return.svg',
    'fuel return': 'icon-fuel-return.svg'
  };
  var productAssetBase = '';
  var MOBILE_TABLE_ICON_EXIT_DELAY_MS = 900;

  function getCellColumnSpan(cell) {
    return Math.max(Number(cell.getAttribute('colspan') || cell.colSpan || 1) || 1, 1);
  }

  function getTableColumnCount(table) {
    return Array.prototype.reduce.call(table.rows, function (maxColumns, row) {
      var rowColumns = Array.prototype.reduce.call(row.cells, function (count, cell) {
        return count + getCellColumnSpan(cell);
      }, 0);
      return Math.max(maxColumns, rowColumns);
    }, 0);
  }

  function detachDesktopTableTitleRow(table, wrapper) {
    if (!table || !wrapper) return;
    if (table.dataset.a24DesktopTitleDetached === '1') return;

    var firstRow = table.querySelector('tbody > tr:first-child');
    if (!firstRow) return;

    var cells = Array.prototype.slice.call(firstRow.children).filter(function (cell) {
      var tag = String(cell.tagName || '').toUpperCase();
      return tag === 'TH' || tag === 'TD';
    });

    if (cells.length !== 1) return;

    var titleCell = cells[0];
    var titleTag = String(titleCell.tagName || '').toUpperCase();
    var titleColspan = getCellColumnSpan(titleCell);
    var titleText = String(titleCell.textContent || '').replace(/\s+/g, ' ').trim();

    if (titleTag !== 'TH' || titleColspan < 2 || !titleText) return;

    var stickyTitle = wrapper.querySelector(':scope > .product-desktop-data-table__sticky-title');
    if (!stickyTitle) {
      stickyTitle = document.createElement('div');
      stickyTitle.className = 'product-desktop-data-table__sticky-title';
      wrapper.insertBefore(stickyTitle, table);
    }

    stickyTitle.textContent = titleText;
    wrapper.classList.add('table-scroll-wrap--with-desktop-sticky-title');
    firstRow.remove();
    table.dataset.a24DesktopTitleDetached = '1';
  }

  function normalizeSpecLabel(label) {
    return String(label || '')
      .trim()
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[–—]/g, '-')
      .replace(/\+/g, ' plus ')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getProductAssetBase() {
    if (productAssetBase) return productAssetBase;

    var script = document.currentScript || document.querySelector('script[src*="a24-product-page.js"]');
    var scriptSource = script && script.src ? String(script.src) : '';

    if (scriptSource.indexOf('/a24-product-page.js') !== -1) {
      productAssetBase = scriptSource.split('/a24-product-page.js')[0] + '/';
    }

    return productAssetBase;
  }

  function getProductAssetUrl(fileName) {
    var assetBase = getProductAssetBase();
    return assetBase ? assetBase + fileName : fileName;
  }

  function getSpecIconFile(label) {
    var normalizedLabel = normalizeSpecLabel(label);
    if (!normalizedLabel) return '';
    if (SPEC_ICON_MAP[normalizedLabel]) return SPEC_ICON_MAP[normalizedLabel];

    var iconKey = Object.keys(SPEC_ICON_MAP)
      .filter(function (key) {
        return normalizedLabel.indexOf(key) !== -1 || key.indexOf(normalizedLabel) !== -1;
      })
      .sort(function (firstKey, secondKey) {
        return secondKey.length - firstKey.length;
      })[0];

    return iconKey ? SPEC_ICON_MAP[iconKey] : '';
  }

  function unwrapMobileLabelContent(cell) {
    var labelContent = cell.querySelector(':scope > .product-mobile-data-table__label-content');
    if (!labelContent) return;

    var labelText = labelContent.querySelector(':scope > .product-mobile-data-table__label-text');
    if (labelText) {
      while (labelText.firstChild) {
        cell.insertBefore(labelText.firstChild, labelContent);
      }
    }

    labelContent.remove();
  }

  function resetMobileTableRowClasses(table) {
    table.querySelectorAll('.product-mobile-data-table__section-filler-cell').forEach(function (cell) {
      cell.remove();
    });

    table.querySelectorAll('.product-mobile-data-table__section-label').forEach(function (label) {
      var parent = label.parentNode;
      if (!parent) return;

      while (label.firstChild) {
        parent.insertBefore(label.firstChild, label);
      }

      label.remove();
    });

    table.querySelectorAll('.product-mobile-data-table__label-cell').forEach(function (cell) {
      unwrapMobileLabelContent(cell);
      cell.classList.remove('product-mobile-data-table__label-cell');
    });

    table.querySelectorAll('.product-mobile-data-table__section-cell[data-mobile-original-colspan]').forEach(function (cell) {
      var originalColspan = Number(cell.dataset.mobileOriginalColspan || 0) || 1;
      cell.colSpan = originalColspan;
      cell.setAttribute('colspan', String(originalColspan));
    });

    table.querySelectorAll('.product-mobile-data-table__section-row, .product-mobile-data-table__two-header-row, .product-mobile-data-table__model-header-row').forEach(function (row) {
      row.classList.remove('product-mobile-data-table__section-row', 'product-mobile-data-table__two-header-row', 'product-mobile-data-table__model-header-row');
    });

    table.querySelectorAll('.product-mobile-data-table__section-cell, .product-mobile-data-table__section-filler-cell, .product-mobile-data-table__first-header-cell').forEach(function (cell) {
      cell.classList.remove('product-mobile-data-table__section-cell', 'product-mobile-data-table__section-filler-cell', 'product-mobile-data-table__first-header-cell');
    });
  }

  function removeTrailingEmptyCells(table) {
    table.querySelectorAll('tr').forEach(function (row) {
      var cells = Array.prototype.slice.call(row.children);
      while (cells.length) {
        var lastCell = cells[cells.length - 1];
        var tag = String(lastCell.tagName || '').toUpperCase();
        var colspan = getCellColumnSpan(lastCell);
        var text = String(lastCell.textContent || '').replace(/\s+/g, ' ').trim();

        if ((tag === 'TD' || tag === 'TH') && colspan === 1 && text === '') {
          lastCell.remove();
          cells.pop();
          continue;
        }
        break;
      }
    });
  }

  function removeCompletelyEmptyRows(table) {
    table.querySelectorAll('tr').forEach(function (row) {
      var cells = Array.prototype.slice.call(row.children).filter(function (cell) {
        var tag = String(cell.tagName || '').toUpperCase();
        return tag === 'TD' || tag === 'TH';
      });

      if (!cells.length) {
        row.remove();
        return;
      }

      var hasVisibleContent = cells.some(function (cell) {
        var text = String(cell.textContent || '').replace(/\s+/g, ' ').trim();
        var hasMedia = Boolean(cell.querySelector('img, svg, picture, video, iframe'));
        return Boolean(text) || hasMedia;
      });

      if (!hasVisibleContent) {
        row.remove();
      }
    });
  }

  function expandMobileSectionRow(row, cell, columnCount) {
    var originalColspan = Number(cell.dataset.mobileOriginalColspan || 0) || getCellColumnSpan(cell);
    var targetColumnCount = Math.max(columnCount, originalColspan, 1);

    cell.dataset.mobileOriginalColspan = String(originalColspan);
    cell.removeAttribute('colspan');
    cell.colSpan = 1;

    for (var columnIndex = 1; columnIndex < targetColumnCount; columnIndex += 1) {
      var fillerCell = document.createElement('th');
      fillerCell.className = 'product-mobile-data-table__section-filler-cell';
      fillerCell.setAttribute('aria-hidden', 'true');
      fillerCell.innerHTML = '&nbsp;';
      row.appendChild(fillerCell);
    }
  }

  function markMobileHeaderRows(table, columnCount) {
    resetMobileTableRowClasses(table);

    var previousRowWasSection = false;

    table.querySelectorAll('tr').forEach(function (row) {
      var cells = Array.prototype.slice.call(row.children).filter(function (cell) {
        var tag = String(cell.tagName || '').toUpperCase();
        return tag === 'TD' || tag === 'TH';
      });

      if (!cells.length) {
        previousRowWasSection = false;
        return;
      }

      var firstTag = String(cells[0].tagName || '').toUpperCase();
      var secondTag = cells[1] ? String(cells[1].tagName || '').toUpperCase() : '';
      var isSectionRow = cells.length === 1 && firstTag === 'TH';
      var isModelHeaderAfterSection = previousRowWasSection && firstTag === 'TH' && secondTag === 'TH';

      if (isSectionRow) {
        row.classList.add('product-mobile-data-table__section-row');
        cells[0].classList.add('product-mobile-data-table__section-cell');
        expandMobileSectionRow(row, cells[0], columnCount);
        previousRowWasSection = true;
        return;
      }

      if (isModelHeaderAfterSection) {
        row.classList.add('product-mobile-data-table__model-header-row');
        cells[0].classList.add('product-mobile-data-table__first-header-cell');
        previousRowWasSection = false;
        return;
      }

      if (firstTag === 'TH' && secondTag === 'TH') {
        row.classList.add('product-mobile-data-table__two-header-row');
        cells[0].classList.add('product-mobile-data-table__first-header-cell');
      }

      previousRowWasSection = false;
    });
  }

  function prepareMobileLabelIcons(table) {
    var iconCount = 0;

    table.querySelectorAll('tr').forEach(function (row) {
      var firstCell = row.querySelector(':scope > th:first-child, :scope > td:first-child');
      if (!firstCell || firstCell.classList.contains('product-mobile-data-table__section-filler-cell')) return;
      if (firstCell.classList.contains('product-mobile-data-table__section-cell')) return;
      if (firstCell.classList.contains('product-mobile-data-table__first-header-cell')) return;
      if (row.classList.contains('product-mobile-data-table__section-row')) return;
      if (row.classList.contains('product-mobile-data-table__model-header-row')) return;
      if (row.classList.contains('product-mobile-data-table__two-header-row')) return;
      if (firstCell.getAttribute('aria-hidden') === 'true') return;

      var labelText = String(firstCell.textContent || '').replace(/\s+/g, ' ').trim();
      var iconFile = getSpecIconFile(labelText);
      if (!labelText || !iconFile) return;

      var labelContent = document.createElement('span');
      var textNodeWrapper = document.createElement('span');
      var iconNodeWrapper = document.createElement('span');
      var iconImage = document.createElement('img');

      labelContent.className = 'product-mobile-data-table__label-content';
      textNodeWrapper.className = 'product-mobile-data-table__label-text';
      iconNodeWrapper.className = 'product-mobile-data-table__label-icon';
      iconNodeWrapper.setAttribute('aria-hidden', 'true');
      iconImage.src = getProductAssetUrl(iconFile);
      iconImage.alt = '';
      iconImage.loading = 'lazy';
      iconImage.decoding = 'async';

      while (firstCell.firstChild) {
        textNodeWrapper.appendChild(firstCell.firstChild);
      }

      iconNodeWrapper.appendChild(iconImage);
      labelContent.appendChild(textNodeWrapper);
      labelContent.appendChild(iconNodeWrapper);
      firstCell.appendChild(labelContent);
      firstCell.classList.add('product-mobile-data-table__label-cell');
      firstCell.dataset.mobileSpecIcon = iconFile;
      iconCount += 1;
    });

    return iconCount > 0;
  }

  function normalizeMobileTableColumns(table, columnCount) {
    var existingColgroup = table.querySelector(':scope > colgroup');
    var colgroup = document.createElement('colgroup');
    var safeColumnCount = Math.max(columnCount, 1);
    var valueColumnCount = Math.max(safeColumnCount - 1, 0);

    for (var columnIndex = 0; columnIndex < safeColumnCount; columnIndex += 1) {
      var column = document.createElement('col');
      column.className = columnIndex === 0
        ? 'product-mobile-data-table__label-column'
        : 'product-mobile-data-table__value-column';

      if (safeColumnCount === 2 && columnIndex === 1) {
        column.className += ' product-mobile-data-table__value-column--fill';
      }

      colgroup.appendChild(column);
    }

    if (existingColgroup) {
      existingColgroup.replaceWith(colgroup);
    } else {
      table.insertBefore(colgroup, table.firstChild);
    }

    table.dataset.mobileColumnCount = String(safeColumnCount);
    table.style.setProperty('--product-mobile-value-column-count', String(valueColumnCount));
    if (valueColumnCount > 0) {
      var collapsedValueColumnWidth = 144 + ((144 - 64) / valueColumnCount);
      table.style.setProperty('--product-mobile-value-column-collapsed-width', collapsedValueColumnWidth.toFixed(4) + 'px');
    }
    table.classList.toggle('product-mobile-data-table--single-value', safeColumnCount === 2);
    table.classList.toggle('product-mobile-data-table--multi-value', safeColumnCount !== 2);

    if (safeColumnCount === 2) {
      table.style.setProperty('--product-mobile-table-width', '100%');
      table.style.setProperty('--product-mobile-table-min-width', '288px');
    } else {
      var expandedTableWidth = String(safeColumnCount * 144) + 'px';
      table.style.setProperty('--product-mobile-table-width', expandedTableWidth);
      table.style.setProperty('--product-mobile-table-min-width', expandedTableWidth);
    }
  }

  function parsePixelValue(value) {
    var parsedValue = parseFloat(String(value || '').replace(',', '.'));
    return Number.isFinite(parsedValue) ? parsedValue : 0;
  }

  function getMobileLabelColumnDelta(wrapper) {
    var styles = window.getComputedStyle(wrapper);
    var expandedWidth = parsePixelValue(styles.getPropertyValue('--product-mobile-label-column-expanded-width')) || 144;
    var collapsedWidth = parsePixelValue(styles.getPropertyValue('--product-mobile-label-column-collapsed-width')) || 64;
    return Math.max(0, expandedWidth - collapsedWidth);
  }

  function setMobileTableScrolledState(wrapper, shouldBeScrolled, preserveAnchor) {
    var wasScrolled = wrapper.classList.contains('table-scroll-wrap--is-scrolled');
    if (wasScrolled === shouldBeScrolled) return;

    var previousScrollLeft = wrapper.scrollLeft;
    var labelColumnDelta = getMobileLabelColumnDelta(wrapper);

    wrapper.classList.toggle('table-scroll-wrap--is-scrolled', shouldBeScrolled);

    if (shouldBeScrolled && preserveAnchor !== false && labelColumnDelta > 0) {
      wrapper.scrollLeft = previousScrollLeft >= labelColumnDelta
        ? previousScrollLeft - labelColumnDelta
        : previousScrollLeft;
    }
  }

  function clearMobileTableRowHeightLocks(table) {
    table.dataset.a24MobileTableRowsLocked = '0';
    table.querySelectorAll('tr').forEach(function (row) {
      row.classList.remove('product-mobile-data-table__locked-row');
      row.style.removeProperty('--product-mobile-row-height');
    });
  }

  function lockMobileTableRowHeights(table, wrapper) {
    if (!table || !wrapper) return false;
    if (table.dataset.a24MobileTableRowsLocked === '1') return true;

    var previousScrollLeft = wrapper.scrollLeft;
    var wasScrolled = wrapper.classList.contains('table-scroll-wrap--is-scrolled');

    wrapper.classList.remove('table-scroll-wrap--is-scrolled');
    clearMobileTableRowHeightLocks(table);

    var lockedRows = 0;
    table.querySelectorAll('tr').forEach(function (row) {
      var cells = row.querySelectorAll(':scope > th, :scope > td');
      if (!cells.length) return;

      var rowHeight = Math.ceil(row.getBoundingClientRect().height || 0);
      if (rowHeight <= 0) return;

      row.style.setProperty('--product-mobile-row-height', rowHeight + 'px');
      row.classList.add('product-mobile-data-table__locked-row');
      lockedRows += 1;
    });

    if (wasScrolled) {
      wrapper.classList.add('table-scroll-wrap--is-scrolled');
    }

    wrapper.scrollLeft = previousScrollLeft;
    table.dataset.a24MobileTableRowsLocked = lockedRows > 0 ? '1' : '0';
    return lockedRows > 0;
  }

  function scheduleMobileTableRowHeightLock(table, wrapper) {
    if (!table || !wrapper) return;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        lockMobileTableRowHeights(table, wrapper);
        updateMobileTableScrollState(wrapper, { preserveAnchor: false });
      });
    });
  }

  function clearMobileTableIconExitTimer(wrapper) {
    if (!wrapper || !wrapper._a24MobileTableIconExitTimer) return;
    window.clearTimeout(wrapper._a24MobileTableIconExitTimer);
    wrapper._a24MobileTableIconExitTimer = 0;
  }

  function scheduleMobileTableIconExit(wrapper, exitThreshold) {
    if (!wrapper || wrapper._a24MobileTableIconExitTimer) return;

    wrapper._a24MobileTableIconExitTimer = window.setTimeout(function () {
      wrapper._a24MobileTableIconExitTimer = 0;

      if (wrapper.scrollLeft <= exitThreshold) {
        setMobileTableScrolledState(wrapper, false, false);
      }
    }, MOBILE_TABLE_ICON_EXIT_DELAY_MS);
  }

  function updateMobileTableScrollState(wrapper, options) {
    var table = wrapper.querySelector(':scope > table.product-mobile-data-table');
    if (table && table.dataset.a24MobileTableRowsLocked !== '1') {
      lockMobileTableRowHeights(table, wrapper);
    }

    var canScroll = wrapper.scrollWidth > wrapper.clientWidth + 2;
    var isScrolledState = wrapper.classList.contains('table-scroll-wrap--is-scrolled');
    var enterThreshold = 4;
    var exitThreshold = 0;

    wrapper.classList.toggle('table-scroll-wrap--can-scroll', canScroll);

    if (!canScroll) {
      clearMobileTableIconExitTimer(wrapper);
      setMobileTableScrolledState(wrapper, false, false);
      return;
    }

    if (isScrolledState) {
      if (wrapper.scrollLeft <= exitThreshold) {
        scheduleMobileTableIconExit(wrapper, exitThreshold);
      } else {
        clearMobileTableIconExitTimer(wrapper);
      }
      return;
    }

    clearMobileTableIconExitTimer(wrapper);

    if (wrapper.scrollLeft > enterThreshold) {
      setMobileTableScrolledState(wrapper, true, !options || options.preserveAnchor !== false);
    }
  }

  function bindMobileTableScrollState(wrapper) {
    if (wrapper.dataset.a24MobileTableScrollBound === '1') {
      updateMobileTableScrollState(wrapper);
      return;
    }

    var ticking = false;
    var scheduleUpdate = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateMobileTableScrollState(wrapper);
      });
    };

    wrapper.dataset.a24MobileTableScrollBound = '1';
    wrapper.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', function () {
      var table = wrapper.querySelector(':scope > table.product-mobile-data-table');
      if (table) {
        clearMobileTableRowHeightLocks(table);
        scheduleMobileTableRowHeightLock(table, wrapper);
      } else {
        updateMobileTableScrollState(wrapper, { preserveAnchor: false });
      }
    }, { passive: true });
    updateMobileTableScrollState(wrapper, { preserveAnchor: false });
  }

  tables.forEach(function (table) {
    var isMobileAccordionTable = Boolean(table.closest('.product-mobile-accordion__content.rte'));

    removeTrailingEmptyCells(table);
    removeCompletelyEmptyRows(table);

    if (!isMobileAccordionTable) {
      var desktopColumnCount = getTableColumnCount(table);
      var isWideDesktopTable = desktopColumnCount >= 4;

      table.classList.toggle('product-desktop-data-table', isWideDesktopTable);
      table.classList.toggle('product-desktop-data-table--compact', !isWideDesktopTable);
    }

    if (isMobileAccordionTable) {
      var mobileColumnCount = Math.max(
        getTableColumnCount(table),
        Number(table.dataset.mobileColumnCount || 0) || 0
      );

      table.classList.add('product-mobile-data-table');
      markMobileHeaderRows(table, mobileColumnCount);
      normalizeMobileTableColumns(table, Math.max(mobileColumnCount, getTableColumnCount(table)));
      table.classList.toggle('product-mobile-data-table--has-label-icons', prepareMobileLabelIcons(table));
    }

    var wrapper = table.parentElement && table.parentElement.classList.contains('table-scroll-wrap')
      ? table.parentElement
      : null;

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'table-scroll-wrap';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    if (!isMobileAccordionTable && table.classList.contains('product-desktop-data-table')) {
      detachDesktopTableTitleRow(table, wrapper);
    }

    if (isMobileAccordionTable) {
      bindMobileTableScrollState(wrapper);
      scheduleMobileTableRowHeightLock(table, wrapper);

      var tableDetails = table.closest('details');
      if (tableDetails && tableDetails.dataset.a24MobileTableHeightBound !== '1') {
        tableDetails.dataset.a24MobileTableHeightBound = '1';
        tableDetails.addEventListener('toggle', function () {
          if (!tableDetails.open) return;
          clearMobileTableRowHeightLocks(table);
          scheduleMobileTableRowHeightLock(table, wrapper);
        });
      }
    }
  });
}
function openLightbox(idx) {
  if (typeof lightboxImages === 'undefined' || !lightboxImages.length) return;
  lightboxIdx = idx || 0;
  var lb = document.getElementById('lightbox');
  if (lb) lb.classList.add('active');
  document.body.classList.add('lightbox-open');
  updateLightbox();
}

function closeLightbox() {
  var lb = document.getElementById('lightbox');
  if (lb) lb.classList.remove('active');
  document.body.classList.remove('lightbox-open');
}

function lightboxNav(dir) {
  if (typeof lightboxImages === 'undefined' || !lightboxImages.length) return;
  lightboxIdx = (lightboxIdx + dir + lightboxImages.length) % lightboxImages.length;
  updateLightbox();
}

function updateLightbox() {
  if (typeof lightboxImages === 'undefined' || !lightboxImages.length) return;
  var img = document.getElementById('lightboxImg');
  var counter = document.getElementById('lightboxCounter');
  if (img) img.src = lightboxImages[lightboxIdx];
  if (counter) counter.textContent = (lightboxIdx + 1) + ' / ' + lightboxImages.length;
}


  function bindLightboxControls() {
    document.querySelectorAll('[data-product-lightbox-close]').forEach(function (element) {
      if (element.dataset.a24LightboxBound === '1') return;
      element.dataset.a24LightboxBound = '1';
      element.addEventListener('click', closeLightbox);
    });

    document.querySelectorAll('[data-product-lightbox-nav]').forEach(function (element) {
      if (element.dataset.a24LightboxBound === '1') return;
      element.dataset.a24LightboxBound = '1';
      element.addEventListener('click', function () {
        lightboxNav(Number(element.getAttribute('data-product-lightbox-nav') || 0));
      });
    });

    document.addEventListener('keydown', function (event) {
      var lightbox = document.getElementById('lightbox');
      if (!lightbox || !lightbox.classList.contains('active')) return;

      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') lightboxNav(-1);
      if (event.key === 'ArrowRight') lightboxNav(1);
    });
  }

  function init() {
    if (initialized || !document.getElementById('ProductForm')) return;

    readConfig();

    initialized = true;

    applyProductInlineSpacing();
    removeBoilerplateDescriptionParagraphs();
    prepareProductTables();
    initProductTabs();
    initProductMediaCarousel();
    bindLightboxControls();

    // Variant-bound logic should not block gallery/tabs initialization.
    if (productData && Array.isArray(productData.variants)) {
      initHighPriceContactGuard();
      syncProductVariantState();
    }
  }

  window.A24ProductPage = {
    init: init,
    openLightbox: openLightbox,
    closeLightbox: closeLightbox,
    lightboxNav: lightboxNav
  };

  /* Backward compatibility for previously rendered product markup. */
  window.openLightbox = openLightbox;
  window.closeLightbox = closeLightbox;
  window.lightboxNav = lightboxNav;

  if (window.A24Theme && typeof window.A24Theme.onReady === 'function') {
    window.A24Theme.onReady(init);
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }

  document.addEventListener('shopify:section:load', function () {
    applyProductInlineSpacing();
  });
}());
